var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({style:(_vm.styles)},_vm.$listeners),[(
      _vm.hasLoadedChartJs && _vm.data && _vm.data.datasets && _vm.data.datasets.length > 0
    )?_c(`Chart${_vm.startCase(_vm.type).replace(/ /g, '')}`,_vm._b({tag:"component",attrs:{"options":_vm.options,"data":_vm.data}},'component',_vm.$attrs,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }